import { render, staticRenderFns } from "./selectgoods.vue?vue&type=template&id=68b9b3c2&scoped=true"
import script from "./selectgoods.vue?vue&type=script&lang=js"
export * from "./selectgoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b9b3c2",
  null
  
)

export default component.exports